export default function IconClose() {
  return (
    <svg
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_close_menu"
    >
      <g id="Icon">
        <path d="m5.64645 5.64645c.19527-.19526.51185-.19526.70711 0l12 12c.19526.19526.19526.51184 0 .7071-.19526.19527-.51184.19527-.7071 0l-12-12c-.19526-.19526-.19526-.51184 0-.7071z"></path>
        <path d="m18.3536 5.64645c.1952.19526.1952.51184 0 .7071l-12 12c-.19526.19527-.51184.19527-.7071 0-.19526-.19526-.19526-.51184 0-.7071l12-12c.1953-.19526.5119-.19526.7071 0z"></path>
      </g>
    </svg>
  );
}
